// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1___9a5b619119e408fc52f","cls2":"ConfirmationModal-cls2__c0848c6fbff620bb2d4c ConfirmationModal-cls1___9a5b619119e408fc52f"};